import * as Swiper from 'swiper/dist/js/swiper.js'; 

export default class keyNumberSlider {
    constructor() {
        this.container = document.querySelector('.cp-key-numbers');
        if (this.container === null) return;

        this.slider = document.querySelector('.js-slider-key-number');

        this.initSlider();

    }

    initSlider(slider) {
		let isMobile;

        if(window.innerWidth < 768){
			isMobile = true
        }else{
			isMobile = false
        }
        new Swiper(this.slider, {
            slidesPerView: isMobile ? 1.2 : 3,
			spaceBetween: isMobile ? 20 : 24,
            slideClass: 'item',
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: '-current',
                clickable: true,
            },
            
        });
    }
}
